'use client'

import { toast } from '@snowball-tech/common/components/Toaster'
import useTranslations from '@snowball-tech/common/hooks/useTranslations'
import { useSearchParams } from 'next/navigation'

import { useEffect } from 'react'

import isEmpty from 'lodash/fp/isEmpty'

export default function HomePageToastDispenser() {
  const searchParams = useSearchParams()
  const $t = useTranslations()

  useEffect(() => {
    const messageKey = searchParams.get('message') ?? ''
    if (isEmpty(messageKey)) {
      return
    }

    let translationKey = `toast.error.${messageKey}`

    switch (messageKey) {
      case 'download-missing-parameters':
      case 'unsubscribe-missing-parameters':
      case 'vote-missing-parameters': {
        const missingParameter = searchParams.get('parameter') ?? ''
        toast.error(
          $t(translationKey, { missingParameter: missingParameter || '' }),
        )
        break
      }

      case 'download-unknown-article':
      case 'download-unknown-edition':
      case 'edition-not-found':
      case 'unauthorized':
      case 'vote-unknown-article':
      case 'vote-unknown-edition': {
        const editionId = searchParams.get('editionId') ?? ''
        if (isEmpty(editionId)) {
          toast.error($t(`${translationKey}.without_edition`, { editionId }))
        } else {
          toast.error($t(`${translationKey}.with_edition`, { editionId }))
        }
        break
      }

      case 'downloaded':
      case 'voted': {
        toast.success($t(`toast.success.${messageKey}`))
        break
      }

      case 'failed-to-unsubscribe': {
        const newsletterName = searchParams.get('newsletterName') ?? ''
        if (isEmpty(newsletterName)) {
          toast.error($t(`${translationKey}.without_name`, { newsletterName }))
        } else {
          toast.error(
            $t.rich(`${translationKey}.with_name`, { newsletterName }),
          )
        }
        break
      }

      case 'payment-successfull':
      case 'signup-successfull': {
        break
      }

      case 'unable-to-signup': {
        const signupError = searchParams.get('signup-error') ?? ''
        if (isEmpty(signupError)) {
          toast.error($t(`toast.error.${messageKey}.no-reason`))
        } else {
          toast.error($t(`toast.error.${messageKey}.${signupError}`))
        }
        break
      }

      case 'unsubscribe-not-logged-in': {
        toast.warning($t(`toast.warning.${messageKey}`))
        break
      }

      case 'unsubscribed': {
        translationKey = `toast.success.${messageKey}`

        const newsletterName = searchParams.get('newsletterName') ?? ''
        if (isEmpty(newsletterName)) {
          toast.success(
            $t(`${translationKey}.without_name`, { newsletterName }),
            $t('my_newsletters.unsubscribe.success.title'),
          )
        } else {
          toast.success(
            $t.rich(`${translationKey}.with_name`, { newsletterName }),
            $t('my_newsletters.unsubscribe.success.title'),
          )
        }
        break
      }

      default: {
        if (messageKey.includes('success')) {
          toast.success($t(translationKey))
        } else if (messageKey.includes('loading')) {
          toast.loading($t(translationKey))
        } else if (messageKey.includes('warning')) {
          toast.warning($t(translationKey))
        } else if (
          messageKey.includes('blank') ||
          messageKey.includes('neutral')
        ) {
          toast.blank($t(translationKey))
        } else {
          toast.error($t(translationKey))
        }
        break
      }
    }
  }, [$t, searchParams])

  return false
}
